import { useState } from 'react';
import { InputHelperText, useGetOne, useInput, type InputProps } from 'react-admin';
import { UserAutocomplete, type AdminUserOption } from './UserAutocomplete';

/** React Admin form/filter adapter. Only the selected ID enters form state. */
export function UserSelectInput(props: InputProps<string> & { label?: string }) {
  const { id, field, fieldState, isRequired } = useInput(props);
  const [selected, setSelected] = useState<AdminUserOption | null>(null);
  const userId = field.value as string | undefined;
  const user = useGetOne<AdminUserOption>('users', { id: userId }, {
    enabled: !!userId && selected?.id !== userId,
  });

  return <UserAutocomplete
    id={id} name={field.name} inputRef={field.ref} onBlur={field.onBlur}
    label={props.label} disabled={props.disabled} required={isRequired}
    value={selected?.id === userId ? selected : user.data ?? null}
    onChange={value => { setSelected(value); field.onChange(value?.id ?? ''); }}
    error={fieldState.invalid || user.isError}
    helperText={user.isError ? 'Could not load the selected user.' :
      <InputHelperText error={fieldState.error?.message} helperText={props.helperText ?? 'Search by name or email'} />}
  />;
}
